<template>
  <div class="PublicacionesEditar">
    <md-card>
      <md-card-header>
        <div class="md-title">Edición de publicación</div>
      </md-card-header>
      <md-card-content>
        <div class="row">
          <div class="col-sm-8">
            <md-field :class="v.titulo_pub">
              <label>Título</label>
              <md-input v-model="publicacion.titulo_pub"></md-input>
              <span class="md-error">Por favor llene este campo</span>
            </md-field>
          </div>
          <div class="col-sm-4">
            <md-field :class="v.id_cat_pub">
              <label for="id_cat_pub">Categoría</label>
              <md-select
                v-model="publicacion.id_cat_pub"
                name="id_cat_pub"
                id="id_cat_pub"
              >
                <md-option
                  v-for="cat in categorias"
                  :key="cat.id_cat"
                  :value="cat.id_cat"
                >{{cat.desc_cat}}</md-option>
              </md-select>
              <span class="md-error">Por favor llene este campo</span>
            </md-field>
          </div>
          <div class="col-sm-12">
            <md-field :class="v.resumen_pub">
              <label>Resumen</label>
              <md-textarea v-model="publicacion.resumen_pub"></md-textarea>
              <span class="md-error">Por favor llene este campo</span>
            </md-field>
          </div>
          <div class="col-sm-4">
            <md-datepicker
              :class="v.fecha_pub"
              v-model="publicacion.fecha_pub"
              :md-open-on-focus="true"
            >
              <label>Fecha de publicación</label>
              <span class="md-error">Llene este campo</span>
            </md-datepicker>
          </div>
          <div class="col-sm-4">
            <md-field :class="v.tipo_pub">
              <label for="tipo_pub">Tipo</label>
              <md-select
                v-model="publicacion.tipo_pub"
                name="tipo_pub"
                id="tipo_pub"
              >
                <md-option value="gratuita">Gratuita</md-option>
                <md-option value="paga">Paga</md-option>
              </md-select>
              <span class="md-error">Por favor llene este campo</span>
            </md-field>
          </div>
          <div class="col-sm-12">
            <md-field>
              <label>Imágen de portada</label>
              <md-file
                v-model="publicacion.archivo"
                accept="image/*"
                placeholder="Seleccione la imágen de portada de la publicación"
                @md-change="archivoSeleccionado($event)"
              />
            </md-field>
          </div>
        </div>
        <span class="md-subheading">Contenido</span>
        <quill-editor
          class="m-b-24"
          v-model="publicacion.contenido_pub"
          :options="editorOption"
        />
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <span class="md-subheading">Agregar referencia</span>
            <md-field :class="v.texto_pre">
              <label>Nombre de la referencia</label>
              <md-input v-model="referencia.texto_pre" />
              <span class="md-error">Por favor llene este campo</span>
            </md-field>
            <md-field :class="v.desc_pre">
              <label>Enlace o bibliografía</label>
              <md-input v-model="referencia.desc_pre" />
              <span class="md-error">Por favor llene este campo</span>
            </md-field>
            <md-button
              class="md-raised md-accent"
              @click.native="agregarReferencias"
            >Agregar</md-button>
          </div>
          <div
            class="col-sm-12 col-md-6"
            v-if="referencias.length>0"
          >
            <span class="md-subheading">Referencias agregadas</span>
            <md-list class="md-double-line">
              <md-list-item
                v-for="(r,index) in referencias"
                :key="index"
              >
                <md-button
                  class="md-icon-button"
                  @click.native="removerReferencia(index)"
                >
                  <md-icon>delete</md-icon>
                  <md-tooltip>Eliminar referencia</md-tooltip>
                </md-button>
                <div class=" md-list-item-text ">
                  <span>{{r.texto_pre}}</span>
                  <p>{{r.desc_pre}}</p>
                </div>
              </md-list-item>
            </md-list>
          </div>
        </div>
        <div class="row m-t-24">
          <div class="col-sm-12 col-md-6">
            <span class="md-subheading">Agregar archivos</span>
            <md-field :class="v.desc_par">
              <label>Descripción del archivo</label>
              <md-input v-model="archivo.desc_par" />
              <span class="md-error">Por favor llene este campo</span>
            </md-field>
            <md-field :class="v.arch_par">
              <label>Archivo</label>
              <md-file
                v-model="file"
                placeholder="Seleccione un archivo"
                @md-change="archivoSeleccionadoArchivito($event)"
              />
              <span class="md-error">Por favor seleccione un archivo</span>
            </md-field>
            <md-button
              class="md-raised md-accent"
              @click.native="agregarArchivo"
            >Agregar</md-button>
          </div>
          <div
            class="col-sm-12 col-md-6"
            v-if="archivos.length>0"
          >
            <span class="md-subheading">Archivos agregados</span>
            <md-list class="md-double-line">
              <md-list-item
                v-for="(a,index) in archivos"
                :key="index"
              >
                <md-button
                  class="md-icon-button"
                  @click.native="removerArchivo(index)"
                >
                  <md-icon>delete</md-icon>
                  <md-tooltip>Eliminar archivo</md-tooltip>
                </md-button>
                <div class="md-list-item-text">
                  <span>{{a.desc_par}}</span>
                  <p>{{a.nombre}}</p>
                </div>
                <md-button
                  class="md-icon-button"
                  @click.native="descargarArchivo(index)"
                  v-if="a.id_par"
                  :href="'http://localhost/cfosc/api/archivos/publicaciones/'+publicacion.id_pub+'/'+a.nombre"
                  download
                  target="_blank"
                >
                  <md-icon>file_download</md-icon>
                  <md-tooltip>Descargar</md-tooltip>
                </md-button>
              </md-list-item>
            </md-list>
          </div>
        </div>
      </md-card-content>
      <md-card-actions>
        <md-button
          class="md-raised md-primary"
          @click.native="guardarPublicacion()"
        >Guardar cambios</md-button>
      </md-card-actions>
    </md-card>
    <md-dialog
      :md-active.sync="cargandoModal"
      :md-close-on-esc="false"
      :md-click-outside-to-close="false"
    >
      <md-dialog-content align="center">
        <p>Un momento por favor, estamos actualizando la publicación</p><br>
        <md-progress-spinner
          md-mode="indeterminate"
          style="position:top!important"
        ></md-progress-spinner>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "PublicacionesEditar",
  methods: {
    obtenerPublicacion() {
      this.$http
        .post("publicaciones/obtener", {
          token: this.$session.get("token"),
          publicacion: this.$route.params.publicacion
        })
        .then(
          response => {
            if (response.status === 200 && "publicacion" in response.body) {
              this.publicacion = response.body.publicacion;
              this.referencias = response.body.referencias;
              this.archivos = response.body.archivos;
            } else {
              this.$parent.sb.texto = response.body.error;
              this.$parent.sb.mostrar = true;
            }
          },
          response => {
            this.$parent.sb.texto =
              "No se pudo establecer conexión para guardar la publicación";
            this.$parent.sb.mostrar = true;
          }
        );
    },
    obtenerCategorias() {
      this.$http
        .post("categorias", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            if (response.status === 200 && "categorias" in response.body) {
              this.categorias = response.body.categorias;
            } else {
              this.$parent.sb.texto = response.body.error;
              this.$parent.sb.mostrar = true;
            }
          },
          response => {
            this.$parent.sb.texto =
              "No se pudo establecer conexión para obtener las categorías de publicación";
            this.$parent.sb.mostrar = true;
          }
        );
    },
    archivoSeleccionado(e) {
      this.publicacion.archivo_pub = e[0];
    },
    guardarPublicacion() {
      if (this.validarCamposPublicacion()) {
        this.publicacion.fecha_pub = this.publicacion.fecha_pub
          ? moment(this.publicacion.fecha_pub).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD");
        var formData = new FormData();
        formData.append("token", this.$session.get("token"));
        formData.append("publicacion", this.publicacion.id_pub);

        formData.append("contenido_pub", btoa(this.publicacion.contenido_pub));
        formData.append("titulo_pub", this.publicacion.titulo_pub);
        formData.append("id_cat_pub", this.publicacion.id_cat_pub);
        formData.append("resumen_pub", this.publicacion.resumen_pub);
        formData.append("tipo_pub", this.publicacion.tipo_pub);
        formData.append("fecha_pub", this.publicacion.fecha_pub);

        //formData.append("dataa", JSON.stringify(this.publicacion));
        formData.append("imagen", this.publicacion.archivo_pub);
        formData.append("archivos", JSON.stringify(this.archivos));
        formData.append("referencias", JSON.stringify(this.referencias));
        for (var x = 0; x < this.archivos.length; x++) {
          formData.append("files[]", this.archivos[x].arch_par);
        }
        this.cargandoModal = true;
        this.$http.post("publicaciones/actualizar", formData).then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              this.$parent.sb.texto = response.body.msg;
              this.$router.push({ name: "PublicacionesListado" });
            } else {
              this.$parent.sb.texto = response.body.error;
            }
            this.$parent.sb.mostrar = true;
            this.cargandoModal = false;
          },
          response => {
            this.$parent.sb.texto =
              "No se pudo establecer conexión para guardar la publicación";
            this.$parent.sb.mostrar = true;
            this.cargandoModal = false;
          }
        );
      }
    },
    validarCamposPublicacion() {
      this.v.titulo_pub = this.publicacion.titulo_pub ? false : "md-invalid";
      this.v.id_cat_pub = this.publicacion.id_cat_pub ? false : "md-invalid";
      this.v.resumen_pub = this.publicacion.resumen_pub ? false : "md-invalid";
      this.v.tipo_pub = this.publicacion.tipo_pub ? false : "md-invalid";
      if (
        this.v.titulo_pub ||
        this.v.id_cat_pub ||
        this.v.resumen_pub ||
        this.v.tipo_pub
      ) {
        this.$parent.sb.texto = "Por favor llene los campos marcados con *";
        this.$parent.sb.mostrar = true;
        return false;
      } else {
        return true;
      }
    },
    agregarReferencias() {
      if (this.validarCamposReferencia()) {
        this.referencias.push({
          texto_pre: this.referencia.texto_pre,
          desc_pre: this.referencia.desc_pre
        });
        this.referencia.texto_pre = null;
        this.referencia.desc_pre = null;
      }
    },
    validarCamposReferencia() {
      this.v.texto_pre = this.referencia.texto_pre ? false : "md-invalid";
      this.v.desc_pre = this.referencia.desc_pre ? false : "md-invalid";
      if (this.v.texto_pre || this.v.desc_pre) {
        return false;
      } else {
        return true;
      }
    },
    removerReferencia(i) {
      this.referencias.splice(i, 1);
    },
    agregarArchivo() {
      if (this.validarCamposArchivo()) {
        this.archivos.push({
          desc_par: this.archivo.desc_par,
          arch_par: this.archivo.arch_par,
          nombre: this.archivo.arch_par.name
        });
        this.file = null;
        this.archivo.desc_par = null;
        this.archivo.arch_par = null;
      }
    },
    validarCamposArchivo() {
      this.v.desc_par = this.archivo.desc_par ? false : "md-invalid";
      this.v.arch_par = this.archivo.arch_par ? false : "md-invalid";
      return this.v.desc_par || this.v.arch_par ? false : true;
    },
    archivoSeleccionadoArchivito(e) {
      this.archivo.arch_par = e[0];
    },
    removerArchivo(i) {
      this.archivos.splice(i, 1);
    }
  },
  data() {
    return {
      file: null,
      archivo: {
        desc_par: null,
        arch_par: null
      },
      archivos: [],
      categorias: [],
      editorOption: {
        placeholder: "Ingrese el contenido aquí"
      },
      publicacion: {
        archivo: null,
        archivo_pub: null,
        titulo_pub: null,
        id_cat_pub: null,
        resumen_pub: null,
        tipo_pub: "paga",
        contenido_pub: null,
        fecha_pub: null
      },
      referencia: {
        texto_pre: null,
        desc_pre: null
      },
      referencias: [],
      archivos_didacticos: [],
      v: {
        titulo_pub: null,
        id_cat_pub: null,
        resumen_pub: null,
        tipo_pub: null,
        contenido_pub: null,
        texto_pre: null,
        liga_pre: null,
        desc_par: null
      },
      cargandoModal: null
    };
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created() {
    this.obtenerCategorias();
    this.obtenerPublicacion();
  }
};
</script>